import { BaseModel } from "./BaseModel";

export class Settings extends BaseModel {
  schema = "/settings";
  constructor(params) {
    return super(params, "/settings");
  }
}
